export default __webpack_public_path__ + "static/Memory-Foam-Pillow 2-a1e1c627971b07e5d182d3d440561df7.png";